// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/grading/v1/grading_settings.proto (package protos.vision.grading.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/grading/v1/grading_settings.proto.
 */
export const file_vision_grading_v1_grading_settings: GenFile = /*@__PURE__*/
  fileDesc("Cih2aXNpb24vZ3JhZGluZy92MS9ncmFkaW5nX3NldHRpbmdzLnByb3RvEhhwcm90b3MudmlzaW9uLmdyYWRpbmcudjEiywYKD0dyYWRpbmdTZXR0aW5ncxIwCgt0ZW1wZXJhdHVyZRgBIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEikKBHRpbnQYAiABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRItCghleHBvc3VyZRgDIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEi0KCGNvbnRyYXN0GAQgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSLwoKaGlnaGxpZ2h0cxgFIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEiwKB3NoYWRvd3MYBiABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRIrCgZibGFja3MYByABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRIpCgRmYWRlGAggASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSLQoIdmlicmFuY2UYCSABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRIvCgpzYXR1cmF0aW9uGAogASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSKgoFZ3JhaW4YCyABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRItCghoYWxhdGlvbhgMIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEi0KCHZpZ25ldHRlGA0gASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSNwoJY3VydmVfcmdiGA4gAygLMiQucHJvdG9zLnZpc2lvbi5ncmFkaW5nLnYxLkN1cnZlUG9pbnQSNQoHY3VydmVfchgPIAMoCzIkLnByb3Rvcy52aXNpb24uZ3JhZGluZy52MS5DdXJ2ZVBvaW50EjUKB2N1cnZlX2cYECADKAsyJC5wcm90b3MudmlzaW9uLmdyYWRpbmcudjEuQ3VydmVQb2ludBI1CgdjdXJ2ZV9iGBEgAygLMiQucHJvdG9zLnZpc2lvbi5ncmFkaW5nLnYxLkN1cnZlUG9pbnQiIgoKQ3VydmVQb2ludBIJCgF4GAEgASgFEgkKAXkYAiABKAViBnByb3RvMw", [file_google_protobuf_wrappers]);

/**
 * @generated from message protos.vision.grading.v1.GradingSettings
 */
export type GradingSettings = Message<"protos.vision.grading.v1.GradingSettings"> & {
  /**
   * @generated from field: google.protobuf.Int32Value temperature = 1;
   */
  temperature?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value tint = 2;
   */
  tint?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value exposure = 3;
   */
  exposure?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value contrast = 4;
   */
  contrast?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value highlights = 5;
   */
  highlights?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value shadows = 6;
   */
  shadows?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value blacks = 7;
   */
  blacks?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value fade = 8;
   */
  fade?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value vibrance = 9;
   */
  vibrance?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value saturation = 10;
   */
  saturation?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value grain = 11;
   */
  grain?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value halation = 12;
   */
  halation?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value vignette = 13;
   */
  vignette?: number | undefined;

  /**
   * @generated from field: repeated protos.vision.grading.v1.CurvePoint curve_rgb = 14;
   */
  curveRgb: CurvePoint[];

  /**
   * @generated from field: repeated protos.vision.grading.v1.CurvePoint curve_r = 15;
   */
  curveR: CurvePoint[];

  /**
   * @generated from field: repeated protos.vision.grading.v1.CurvePoint curve_g = 16;
   */
  curveG: CurvePoint[];

  /**
   * @generated from field: repeated protos.vision.grading.v1.CurvePoint curve_b = 17;
   */
  curveB: CurvePoint[];
};

/**
 * Describes the message protos.vision.grading.v1.GradingSettings.
 * Use `create(GradingSettingsSchema)` to create a new message.
 */
export const GradingSettingsSchema: GenMessage<GradingSettings> = /*@__PURE__*/
  messageDesc(file_vision_grading_v1_grading_settings, 0);

/**
 * @generated from message protos.vision.grading.v1.CurvePoint
 */
export type CurvePoint = Message<"protos.vision.grading.v1.CurvePoint"> & {
  /**
   * @generated from field: int32 x = 1;
   */
  x: number;

  /**
   * @generated from field: int32 y = 2;
   */
  y: number;
};

/**
 * Describes the message protos.vision.grading.v1.CurvePoint.
 * Use `create(CurvePointSchema)` to create a new message.
 */
export const CurvePointSchema: GenMessage<CurvePoint> = /*@__PURE__*/
  messageDesc(file_vision_grading_v1_grading_settings, 1);

